import React, { FC } from 'react'

import { highlightCudaCode } from './highlighter'
import classes from './style.module.scss'

interface ComponentProps {
  code: string
  highlight?: boolean
}

export const CodeSnippet: FC<ComponentProps> = ({ code, highlight = false }) => {
  const content = highlight ? highlightCudaCode(code) : code

  return (
    <div className={classes.container}>
      <pre className={classes.pre}>
        {highlight ? (
          <code dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <code>{content}</code>
        )}
      </pre>
    </div>
  )
}